window.process = { 
  env: { 
    BUN_PUBLIC_SUPABASE_URL: "https://zihqlfxonflidjspkabb.supabase.co",
    BUN_PUBLIC_SUPABASE_ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InppaHFsZnhvbmZsaWRqc3BrYWJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgwMTI2MTAsImV4cCI6MjA4MzU4ODYxMH0.RMIqXYjL8dvRLnWt9TjPS8hvKoJmIPanZMVkczW0orE",
    BUN_PUBLIC_GEMINI_API_KEY: "",
    BUN_PUBLIC_API_URL: "https://assistente-educacional.onrender.com",
    NODE_ENV: "production"
  } 
};